import React from 'react';

interface JSONModalProps {
    isOpen: boolean;
    onClose: () => void;
    data: any;
    title?: string;
}

const JSONModal: React.FC<JSONModalProps> = ({ isOpen, onClose, data, title }) => {
    if (!isOpen) return null;

    let formattedJson = '';
    try {
        // If data is a string, try to parse it first to ensure pretty printing works
        const obj = typeof data === 'string' ? JSON.parse(data) : data;
        formattedJson = JSON.stringify(obj, null, 2);
    } catch (e) {
        formattedJson = String(data);
    }

    return (
        <div style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 1000
        }} onClick={onClose}>
            <div style={{
                backgroundColor: 'white',
                padding: '20px',
                borderRadius: '8px',
                maxWidth: '80%',
                maxHeight: '80%',
                overflow: 'auto',
                position: 'relative',
                display: 'flex',
                flexDirection: 'column'
            }} onClick={e => e.stopPropagation()}>
                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '10px' }}>
                    <h3 style={{ margin: 0 }}>{title || 'JSON Data'}</h3>
                    <button onClick={onClose} style={{ cursor: 'pointer' }}>Close</button>
                </div>
                <pre style={{
                    backgroundColor: '#f4f4f4',
                    padding: '10px',
                    borderRadius: '4px',
                    overflow: 'auto',
                    margin: 0
                }}>
                    {formattedJson}
                </pre>
            </div>
        </div>
    );
};

export default JSONModal;

